import { render, staticRenderFns } from "./infoResponsiblePayment.vue?vue&type=template&id=3efbb3b2&scoped=true"
import script from "./infoResponsiblePayment.vue?vue&type=script&lang=js"
export * from "./infoResponsiblePayment.vue?vue&type=script&lang=js"
import style0 from "./infoResponsiblePayment.vue?vue&type=style&index=0&id=3efbb3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efbb3b2",
  null
  
)

export default component.exports